import React from 'react';
const platforms = [{
  name: 'Spotify',
  link: 'https://open.spotify.com/show/4IHMpSES2R4Zx4t0Et2oX8',
  logo: <svg width="48" height="48" viewBox="0 0 24 24" fill="#1DB954" xmlns="http://www.w3.org/2000/svg" data-id="element-138">
        <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.48.659.24 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.84.24 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.6.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.54-1.02.72-1.56.3z" data-id="element-139" />
      </svg>
}, {
  name: 'YouTube',
  link: 'https://www.youtube.com/@EofApod',
  logo: <svg width="48" height="48" viewBox="0 0 24 24" fill="#FF0000" xmlns="http://www.w3.org/2000/svg" data-id="element-140">
        <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" data-id="element-141" />
      </svg>
}];
export function SubscribePlatforms() {
  return <section className="bg-eofa-yellow py-20 md:py-32" data-id="element-142">
      <div className="container mx-auto px-6" data-id="element-143">
        <div className="max-w-[900px] mx-auto text-center" data-id="element-144">
          <h2 className="text-eofa-black font-heading font-black text-[36px] md:text-[56px] leading-[1.1] tracking-tighter mb-4" data-id="element-145">
            New episodes every single day.
          </h2>
          <p className="text-eofa-black text-lg md:text-xl font-medium mb-12" data-id="element-146">
            Subscribe wherever you listen.
          </p>

          {/* Platform Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-147">
            {platforms.map(platform => <a key={platform.name} href={platform.link} target="_blank" rel="noopener noreferrer" className="bg-white rounded-xl shadow-lg p-8 flex flex-col items-center justify-center min-h-[180px] hover:scale-105 hover:shadow-2xl transition-all duration-300 group" data-id="element-148">
                <div className="mb-4 group-hover:scale-110 transition-transform" data-id="element-149">
                  {platform.logo}
                </div>
                <h3 className="text-eofa-black font-bold text-xl mb-2" data-id="element-150">
                  {platform.name}
                </h3>
                <span className="text-eofa-black/70 text-sm font-medium group-hover:text-eofa-black transition-colors" data-id="element-151">
                  Subscribe
                </span>
              </a>)}
          </div>
        </div>
      </div>
    </section>;
}